export enum ProductPortalApiUrls {
    GetProducts='/api/ProductPortal/GetAllProducts',
  }